import React from 'react';
import moment from 'moment-timezone';

import useStyles from './styles';

import { basicReducer as reducer } from '../../../../utils/reducers';

const initState = {
    show_entryDateError: false,
    show_exitDateError: false,
    exitDate: null,
    entryDate: null,
    errors: [
        {
            key: 'exitDate',
            exitDateError: true,
            exitDateErrorMessage: 'Exit Date is required.',
        },
        {
            key: 'entryDate',
            entryDateError: true,
            entryDateErrorMessage: 'Exit Date is required.',
        },
    ],
};

const useEnrollmentModal = () => {
    const styles = useStyles();

    const [state, dispatch] = React.useReducer(reducer, initState);

    const initDates = (exit, entry) =>
        dispatch({
            type: 'update',
            newState: {
                exitDate: moment.tz(exit, 'America/Chicago'),
                entryDate: moment.tz(entry, 'America/Chicago'),
                errors: [],
            },
        });

    const resetDates = () => {
        dispatch({
            type: 'update',
            newState: {
                ...initState,
                errors: [
                    {
                        key: 'exitDate',
                        exitDateError: true,
                        exitDateErrorMessage: 'Exit Date is required.',
                    },
                    {
                        key: 'entryDate',
                        entryDateError: true,
                        entryDateErrorMessage: 'Exit Date is required.',
                    },
                ],
            },
        });
    };

    const handleDateChange = (_date, key) => {
        let newState = {
            [key]: _date,
            [`show_${key}Error`]: false,
        };

        let error = { key };

        if (_date === null) {
            error[`${key}Error`] = true;
            error[`${key}ErrorMessage`] = `${key === 'entryDate' ? 'Entry' : 'Exit'} Date is required.`;

            newState.errors = [...state?.errors?.filter((err) => err?.key !== key), error];
        }

        dispatch({
            type: 'update',
            newState,
        });
    };

    const handleDateBlur = (key) => {
        let newState = {
            [`show_${key}Error`]: true,
        };

        dispatch({
            type: 'update',
            newState,
        });
    };

    const handleDateError = (err, val, key) => {
        let _err = state?.errors?.find((err) => err?.key === key) || {
            key,
        };

        if (val === null || val?.toISOString?.() === null) {
            _err[`${key}Error`] = true;
            _err[`${key}ErrorMessage`] = `${key === 'entryDate' ? 'Entry' : 'Exit'} Date is required.`;
        } else if (err === 'minDate') {
            _err[`${key}Error`] = true;
            _err[`${key}ErrorMessage`] = `${key === 'entryDate' ? 'Entry' : 'Exit'} Date must be more recent.`;
        } else if (err === 'maxDate') {
            _err[`${key}Error`] = true;
            _err[`${key}ErrorMessage`] = `${key === 'entryDate' ? 'Entry' : 'Exit'} Date must be in the past.`;
        } else if (err === null) {
            _err[`${key}Error`] = false;
            _err[`${key}ErrorMessage`] = null;
        } else return;

        dispatch({
            type: 'update',
            newState: {
                errors:
                    _err?.[`${key}Error`] === true
                        ? [...state?.errors?.filter((err) => err?.key !== key), _err]
                        : [...state?.errors?.filter((err) => err?.key !== key)],
            },
        });
    };

    return {
        ...state,
        ...styles,
        initDates,
        resetDates,
        handleDateBlur,
        handleDateChange,
        handleDateError,
    };
};

export default useEnrollmentModal;
